import React from 'react';
import { analytics } from 'lib/analytics';
import { Outlet } from 'react-router-dom';
import {
  GridMain,
  BoxCenter,
  BoxLeading,
  BoxTrailing,
  CardWrapper,
  Card,
} from 'features/freeTrial';
import { setPublicPageTitle } from 'helpers/documentHelper';
import config from 'data/config';
import FreeTrialProvider from 'providers/FreeTrialProvider';

export default function FreeTrial() {
  setPublicPageTitle('Free Trial');

  analytics.config(config.amplitudeWFHApiKey);

  return (
    <FreeTrialProvider>
      <GridMain>
        <BoxCenter>
          <CardWrapper>
            <Card>
              <Outlet />
            </Card>
          </CardWrapper>
        </BoxCenter>
        <BoxLeading />
        <BoxTrailing />
      </GridMain>
    </FreeTrialProvider>
  );
}
